module.exports = __webpack_public_path__ + "static/media/detail_0043_f.f5f723ce.jpg";